import type { Metadata } from 'next';

import {
  execute,
  GetBlogTopicsDocument,
  GetRouteDocument
} from '@/fo/api/magento';

/** Получает метаданные страницы топика с приоритетом SEO */
export async function getTopicMetadata({
  topic,
  pathname
}: {
  topic: string;
  pathname: string;
}): Promise<Metadata> {
  const [routeData, topicData] = await Promise.all([
    execute(GetRouteDocument, {
      url: `${pathname}/${topic}/`
    }),
    execute(GetBlogTopicsDocument, { urlKey: topic })
  ]);

  const topicItem = topicData.data?.mpBlogTopics?.items?.[0];
  const seoTitle =
    routeData.data?.seoParams?.meta_title?.trim() ||
    topicItem?.meta_title?.trim() ||
    '';
  const seoDescription =
    routeData.data?.seoParams?.meta_description?.trim() ||
    topicItem?.meta_description?.trim() ||
    '';
  const seoRobots = topicItem?.meta_robots?.trim() || '';

  if (!seoTitle && !seoDescription && !seoRobots) {
    return {};
  }

  return {
    title: seoTitle || undefined,
    description: seoDescription || undefined,
    robots: seoRobots || undefined
  };
}
